import { Agent } from '../model/types';

export const formatAgentName = (
  agent: Pick<Agent, 'firstName' | 'middleName' | 'lastName'>
) => {
  const parts = [agent.firstName, agent.middleName, agent.lastName].filter(
    Boolean
  );
  return parts.join(' ') || 'Unnamed agent';
};
